import { useFormSchema } from "src/api/hooks/useFormSchema";
export const PasswordWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;

  return (
    <div className={`password-container container`}>
      <input
        type="password"
        className={`input-password`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
      />
    </div>
  );
};
